import { PropsWithChildren, useLayoutEffect, useRef, useState } from 'react'
import { IconTrash } from '../../../../shared/components/icons/IconTrash'
import { Tooltip } from '../../../../shared/components/text/tooltip/Tooltip'
import { Badge } from '../../../ui/badge/component/badge/Badge'
import { BADGE_COLOR, TBadgeColorKey } from '../../../ui/badge/const/badge-color.const'

interface TagProps extends PropsWithChildren {
  id?: number
  color?: TBadgeColorKey
  maw?: number
  onClear?: (id: number) => void
}

export const Tag = ({ children, id, color, maw, onClear }: TagProps) => {
  const [width, setWidth] = useState<number | undefined>(maw)

  const textRef = useRef<HTMLSpanElement>(null)

  useLayoutEffect(() => {
    if (!textRef.current || !maw) return

    const textWidth = textRef.current.offsetWidth

    if (textWidth < maw) {
      setWidth(textWidth > 24 ? textWidth : 24)
    }
  }, [children])

  return (
    <Badge color={color}>
      <div
        style={{
          minWidth: width,
          maxWidth: width ?? 'fit-content',
        }}
        className={'group flex h-fit w-full items-center justify-center gap-[4px]'}
      >
        <Tooltip title={onClear ? children : null}>
          <span ref={textRef} className={'truncate font-semibold'}>
            {children}
          </span>
        </Tooltip>
        {!!id && !!onClear && (
          <button
            className={'ml-auto hidden w-[10px] min-w-[10px] cursor-pointer group-hover:block'}
            onClick={() => {
              onClear(id)
            }}
          >
            <IconTrash color={color ? BADGE_COLOR[color].color : '#F48C06'} />
          </button>
        )}
      </div>
    </Badge>
  )
}
